export const API_HOSTNAME =
  import.meta.env.VITE_API_HOSTNAME ?? "http://localhost:8000/"
